import angular from 'angular';

import Browser from 'cars-ng-browser';
import Listing from '../listing';
import component from './asyncDataTracking.component';
import recentActivityService from './recentlyActivity.service';
import Seller from '../sellerData';
import NgTracking from 'cars-ng-tracking';
import DealerChat from '../dealerChat';
import SimilarVehicles from '../similarVehicles';
import ngUser from 'cars-ng-user';

export default angular.module('vdp.asyncDataTracking', [
    Listing, Browser, Seller, NgTracking, DealerChat, SimilarVehicles, ngUser
])

.component('vdpAsyncDataTracking', component)
    .factory('recentActivityService', recentActivityService)

.name;
